var voted_users_rtlignore_default = {
  "container": "jNe2D",
  "webview": "JzNMQ",
  "avatar_list": "xViZ7",
  "avatar": "CP76e",
  "user_avatar": "-x92Z",
  "modal": "_50JwB",
  "voted_users_modal": "aCOA8",
  "overlay": "_7KTcq",
  "user_card": "Mvmq0",
  "user_name": "ml9lP",
  "voted_users_modal_header": "d7ZHZ",
  "cta": "QkEAb",
  "close_icon": "_6nP1m",
  "title": "QfKWG",
  "member_list_container": "vpl--",
  "member_list": "_1JoE2",
  "loader": "_4JsNf",
  "anonymous_counter": "Y0IbN",
  "spinner": "_71-tE",
  "spin": "tZaaw"
};
export {
  voted_users_rtlignore_default as default
};
//# sourceMappingURL=voted-users.rtlignore-scss.js.map
